<router-outlet></router-outlet>

<ngx-spinner type = "square-loader" bdColor="rgba(0, 0, 0, 0.1)" color="#0D6938">
    <span class="text-spinner">...جاري التحميل</span>
  </ngx-spinner>